import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import { LEGAL_DOCS } from "@/content/legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <main className="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center">
    <h1 className="font-spartan text-[32px] font-bold text-black">
      Page not found
    </h1>
    <p className="mt-4 font-glacial text-[16px] text-[#7C7C7C]">
      The page you are looking for does not exist.
    </p>
    <a
      href="/"
      data-testid="not-found-home-link"
      className="mt-8 rounded-full bg-black px-6 py-3 font-spartan text-[14px] font-bold text-white"
    >
      Back to home
    </a>
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {LEGAL_DOCS.map((doc) => (
          <Route
            key={doc.slug}
            path={doc.slug}
            element={<LegalPage doc={doc} />}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
